import Base from './base'
import Request from '@utils/request'
import { toQueryString } from '@utils'

class Report extends Base {
  async totalPoints (payload = {}) {
    const url = `/api/admin/report/points?${toQueryString(payload)}`
    const response = await Request.get(url)

    return response
  }
}

export default new Report()
